// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"64ab45f7ae30a138d6c1","883":"9f171d0e4c3e7279a21b"}[chunkId] + ".js";
};